import { translation, format, TranslatedComponent, numberFormatter } from '@hh.ru/front-static-app';

import { Currency } from 'src/types/common';
import { currencySymbols } from 'src/utils/currency';

import styles from './styles.less';

const TrlKeys = {
    title: 'career-platform.profession.sections.calculator.tablo.salary.title',
    value: 'career-platform.profession.sections.calculator.tablo.salary.value',
};

interface Props {
    init: boolean;
    value: number;
    total: number;
}

const getProgressValue = (value: number, total: number) => {
    const result = (value / total) * 100;
    return isNaN(result) ? 0 : `${result.toFixed(2)}%`;
};

const ItemSalary: TranslatedComponent<Props> = ({ trls, init, value, total }) => (
    <>
        {init && <p className={styles.itemDescription}>{trls[TrlKeys.title]}</p>}
        {!init && (
            <>
                <p className={styles.itemHeading} data-qa="calculator-tablo-salary">
                    {format(trls[TrlKeys.value], {
                        '{from}': numberFormatter.format(value.toString()),
                        '{to}': numberFormatter.format(total.toString()),
                        '{currency}': currencySymbols[Currency.RUB],
                    })}
                </p>
                <div className={styles.itemSalaryProgress}>
                    <div
                        className={styles.itemSalaryProgressContent}
                        style={{ width: getProgressValue(value, total) }}
                    />
                </div>
            </>
        )}
    </>
);

export default translation(ItemSalary);
